{
  "cancelOrder": {
    "title": "Cancel order",
    "ticker": "Ticker",
    "operation": "Operation",
    "quantity": "Quantity",
    "price": "Price",
    "orderType": "Order Type",
    "executed": "Executed",
    "orderDuration": "Order Duration",
    "stopPrice": "Stop Price",
    "limitPrice": "Limit Price",
    "stopLoss": "Stop Loss",
    "takeProfit": "Take Profit",
    "complexOrders": "Order group",
    "no": "No",
    "yes": "Yes",
    "status": {
      "new": "New",
      "partially_filled": "Partially Filled",
      "filled": "Filled",
      "done_for_day": "Done For Day",
      "canceled": "Canceled",
      "expired": "Expired",
      "replaced": "Replaced",
      "pending_cancel": "Pending Cancel",
      "pending_replace": "Pending Replace",
      "accepted": "Accepted",
      "pending_new": "Pending New",
      "rejected": "Rejected",
      "calculated": "Calculated",
      "accepted_for_bidding": "Accepted for Bidding",
      "stopped": "Stopped",
      "suspended": "Suspended",
      "held": "Held"
    },
    "side": {
      "buy": "Buy",
      "sell": "Sell",
      "sell_short": "Sell Short"
    },
    "types": {
      "market": "Market",
      "limit": "Limit",
      "stop": "Stop",
      "stop_limit": "Stop Limit",
      "trailing_stop": "Trailing Stop"
    },
    "terms": {
      "day": "DAY",
      "gtc": "GTC",
      "opg": "OPG",
      "cls": "CLS",
      "ioc": "IOC",
      "dayPlus": "DAY+"
    },
    "attributes": {
      "stop_loss": "Stop Loss",
      "take_profit": "Take Profit"
    }
  }
}
